/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shopping-bag-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M20.858 21H3.142l-.14 2.952A1 1 0 0 0 4 25h16a1 1 0 0 0 .999-1.048zM20.094 4.952A1 1 0 0 0 19.095 4H16a4 4 0 0 0-8 0H4.905a1 1 0 0 0-.999.952L3.19 20h17.62zM9 8.5a.5.5 0 0 1-1 0V5h1zM12 1a3.003 3.003 0 0 1 3 3H9a3.003 3.003 0 0 1 3-3zm4 7.5a.5.5 0 1 1-1 0V5h1z"/>'
  }
})
